import FluxStore from "./FluxStore";

import AppConstants from "../constants/AppConstants";

import AppDispatcher from "../dispatcher/AppDispatcher";

// Define initial data points
let tags = [];
let initialized = false;

// Extend TagStore with EventEmitter to add eventing capabilities
class TagStore extends FluxStore
{
	getIsInitialized()
	{
		return initialized;
	}

	getTags()
	{
		return tags;
	}
}

const tagStore = new TagStore();

tagStore.dispatchToken = AppDispatcher.register((action) => {
	let index = -1;
	switch (action.actionType) {
		case AppConstants.TAGSTORE_RECEIVE_DATA:
			initialized = true;
			tags = action.tags;
			break;

		case AppConstants.TAGSTORE_SAVE_SUCCESS:
			index = tags.map(t => t.id).indexOf(action.tag.id);
			if (index !== -1)
			{
				tags[index] = action.tag;
			}
			else
			{
				index = tags.length;
				tags.push(action.tag);
			}
			break;

		case AppConstants.TAGSTORE_DELETE_SUCCESS:
			index = tags.map(t => t.id).indexOf(action.tagId);
			if (index !== -1)
			{
				tags.splice(index, 1);
			}
			break;

		default:
			return true;
	}

	// If action was responded to, emit change event
	tagStore.emitChange();
	return true;
});

export default tagStore;



// WEBPACK FOOTER //
// ./Components/stores/TagStore.jsx